export default "__VITE_ASSET__CDssUXXf__"